import type { IReferenceWellsFullInfoApi, TWellChildrenCatalog } from '@repo/reference-wells';

import { requireService } from 'src/packages/di';
import type { IDirectoriesService } from 'src/packages/directories/IDirectoriesService';

import { enrichReferenceWellChildrenByWellId, loadWellboreTypeLookup } from './enrich-reference-well-children';

/**
 * Wraps transport full-info API and enriches wellbores from directories.
 * Keeps ReferenceWellsFullInfoApi as pure transport.
 */
export function createEnrichedReferenceWellsFullInfoApi(
  inner: IReferenceWellsFullInfoApi,
  directories: IDirectoriesService = requireService('directories'),
): IReferenceWellsFullInfoApi {
  return {
    async fetchChildren(): Promise<Map<number, TWellChildrenCatalog>> {
      const [childrenByWellId, lookup] = await Promise.all([
        inner.fetchChildren(),
        loadWellboreTypeLookup(directories),
      ]);

      return enrichReferenceWellChildrenByWellId(childrenByWellId, lookup);
    },
  };
}
